import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsdate-picker',
	templateUrl:'./BSDatePickerPage.html',
	styles: [],
	styleUrls:['./BSDatePickerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSDatePickerPage
{
	mdContent_99 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.datepicker.BSDatePicker;
\`\`\``;
	mdContent_100 = `\`\`\`java
new BSDatePicker<>()
\`\`\``;
	mdContent_101 = `\`\`\`java
var datePicker = new BSDatePicker<>();
form.add(datePicker);
\`\`\``;
}
